import React, { useState } from 'react';
import { RefreshCcwIcon } from 'lucide-react';
import { DashboardFilters } from '../components/dashboard/DashboardFilters';
import { BarChart } from '../components/dashboard/charts/BarChart';
import { LineChart } from '../components/dashboard/charts/LineChart';
import { DashboardTable } from '../components/dashboard/DashboardTable';
import { ExportPanel } from '../components/dashboard/ExportPanel';
export const Dashboard = () => {
  const [filters, setFilters] = useState({});
  const [isRefreshing, setIsRefreshing] = useState(false);
  const handleRefresh = () => {
    setIsRefreshing(true);
    // Simulate data refresh
    setTimeout(() => setIsRefreshing(false), 1000);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1381">
      <main className="pt-16 pl-64" data-id="element-1382">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1383">
          <div className="flex justify-between items-center mb-6" data-id="element-1384">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-1385">
              Dashboard Comercial
            </h1>
            <div className="flex items-center gap-4" data-id="element-1386">
              <ExportPanel data-id="element-1387" />
              <button onClick={handleRefresh} className={`p-2 text-gray-600 hover:text-gray-900 rounded-full transition-all duration-200 ${isRefreshing ? 'animate-spin' : ''}`} data-id="element-1388">
                <RefreshCcwIcon className="h-5 w-5" data-id="element-1389" />
              </button>
            </div>
          </div>
          <DashboardFilters onFilterChange={setFilters} data-id="element-1390" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6" data-id="element-1391">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1392">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1393">Ingresos Mensuales</h2>
              <BarChart data-id="element-1394" />
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1395">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1396">
                Tendencia de Ventas
              </h2>
              <LineChart data-id="element-1397" />
            </div>
          </div>
          <div className="mt-6" data-id="element-1398">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1399">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1400">
                Detalle de Operaciones
              </h2>
              <DashboardTable data-id="element-1401" />
            </div>
          </div>
        </div>
      </main>
    </div>;
};